import * as angular from 'angular';

/**
 * @ngdoc service
 * @name mwBannerService
 * @module mw.components.banner
 *
 * @description
 * A service used to open banners,
 * the service expects you to pass it a string or html in which is will procces
 * as well as a onClose event (optional) if there is any additional
 * functionality you need to take care of when closing the banner
 */

/**
 * @ngdoc method
 * @name mwBannerService#open
 * @param {string|object} [config] - String of content (can be HTML) that will be displayed in the banner OR banner panel config override
 *
 *
 * @returns promise that resolves with a reference to the $mdPanelRef
 */

export class BannerService {
    bannerGroups = 0;

    constructor(private $window, private $mdPanel) {
        'ngInject';
    }

    open(bannerConfig: string | ng.material.IPanelConfig = {}) {
        let attachToDefaultSelector = '.mw-app-container__main > md-content';

        let attachTo = (typeof bannerConfig === 'object' && bannerConfig.attachTo) ? bannerConfig.attachTo : attachToDefaultSelector;
        attachTo = typeof attachTo === 'string' ? this.$window.document.querySelector(attachTo) : attachTo;

        let attachToElement: JQuery<HTMLElement> = angular.element(attachTo);
        attachToElement = attachToElement.length ? attachToElement : angular.element(this.$window.document.body);

        let bannersContainer = attachToElement.find('mw-banners');
        if (!bannersContainer.length) {
            attachToElement.append('<mw-banners-scroller><mw-banners></mw-banners></mw-banners-scroller>');
            bannersContainer = attachToElement.find('mw-banners')
        }

        if (!bannersContainer.prop('mwBannersGroup')) {
            bannersContainer.prop('mwBannersGroup', 'mwBannersGroup' + this.bannerGroups++);
        }

        let panelPosition = this.$mdPanel.newPanelPosition()
            .absolute()
            .top('0')
            .right('0');

        let panelAnimation = this.$mdPanel.newPanelAnimation()
            .duration(200)
            .withAnimation(this.$mdPanel.animation.FADE);

        let panelConfig = Object.assign({
                attachTo: bannersContainer,
                controllerAs: '$ctrl',
                controller: class BannerPanel {
                    constructor(private mdPanelRef) {
                        'ngInject';
                    }

                    close() {
                        this.mdPanelRef.close();
                    }
                },
                template: `
                    <mw-banner on-close="$ctrl.close($event)">{{$ctrl.text}}</mw-banner>
                `,
                locals: {
                    text: bannerConfig
                },
                panelClass: 'mw-banner__panel',
                focusOnOpen: false,
                propagateContainerEvents: true,
                groupName: bannersContainer.prop('mwBannersGroup'),
                position: panelPosition,
                animation: panelAnimation,
            },
            (typeof bannerConfig === 'object') ? bannerConfig : {}
        );

        return this.$mdPanel.open(panelConfig);
    }

}



// WEBPACK FOOTER //
// ./src/lib/components/banner/banner.service.ts